import React, { useState, useRef } from "react";
import { SubmitHandler, FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import * as Yup from 'yup';
import { BASE_URL } from "utils/requests";
import Input from "components/Form/Input";
import { authHeader, handleResponse } from "helpers";
import { alertService } from "services";

interface FormData {
    email: string
}

const ResetPasswordUser = (props: any) => {
    const formRef = useRef<FormHandles>(null)
    const [saving, setSaving] = useState(false);

    const handleSubmit: SubmitHandler<FormData> = async data => {
        try {
            const schema = Yup.object().shape({
                email: Yup.string().email("Digite um e-mail válido").required("O email é obrigatório"),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            formRef.current?.setErrors({});

            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            }

            setSaving(true);
            fetch(`${BASE_URL}/users/resetpassword?email=${data.email}`, requestOptions)
                .then(handleResponse)
                .then(response => {
                    alertService.success(response.data);
                    formRef.current?.reset();
                    setTimeout(() => props.history.push("/"), 5000);
                })
                .catch(error => {
                    setSaving(false);
                    alertService.error(error);
                });
        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                let errorMessages: { [key in string]: string };
                errorMessages = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    errorMessages[error.path!] = error.message;
                });
                formRef.current?.setErrors(errorMessages);
            }
        }
    }

    return (
        <div className="container">
            <h3 className="display-5 font-weight-light text-secondary">Esqueci minha senha</h3>
            <p className="lead font-weight-light text-secondary">Digite o seu email abaixo:</p>
            <Form ref={formRef} onSubmit={handleSubmit}>
                <div className="jumbotron shadow rounded bg-white mt-5 pt-4">
                    <Input label="E-mail" name="email" type="text" placeholder="Digite o seu e-mail cadastrado no sistema" />
                    <div className="form-actions">
                        <a href="/" className="btn btn-outline-secondary">Cancelar</a>
                        <button type="submit" className={"btn btn-primary" + (saving ? " btn-loading" : "")} disabled={saving}>Trocar Senha</button>
                    </div>
                </div>
            </Form>
        </div>
    );
}

export default ResetPasswordUser;
